import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { GalleriaModule } from 'primeng/galleria';
import { Image } from 'src/app/models/Image';
// import { PhotoService } from 'src/app/services/photo/photo.service';

// import { GalleriaModule } from 'primeng/galleria';
@Component({
  selector: 'app-main-gallery',
  templateUrl: './main-gallery.component.html',
  styleUrls: ['./main-gallery.component.scss'],
  standalone: true,
  imports: [GalleriaModule, ButtonModule],
})
export class MainGalleryComponent implements OnInit {
  images: Image[] = [];

  // responsiveOptions: any[] = [
  //   {
  //     breakpoint: '1024px',
  //     numVisible: 3,
  //   },
  //   {
  //     breakpoint: '768px',
  //     numVisible: 3,
  //   },
  //   {
  //     breakpoint: '560px',
  //     numVisible: 1,
  //   },
  // ];

  // responsiveOptions2: any[] = [
  //   {
  //     breakpoint: '1500px',
  //     numVisible: 3,
  //   },
  //   {
  //     breakpoint: '1024px',
  //     numVisible: 3,
  //   },
  //   {
  //     breakpoint: '768px',
  //     numVisible: 2,
  //   },
  //   {
  //     breakpoint: '560px',
  //     numVisible: 1,
  //   },
  // ];

  displayBasic: boolean = true;

  displayBasic2: boolean = true;

  displayCustom: boolean = false;

  activeIndex: number = 0;

  // constructor(private photoService: PhotoService) {}

  ngOnInit() {
    // this.photoService.getImages().then((images: any[]) => {
    //   this.images = images;
    // });
    this.images = [
      {
        previewImageSrc: 'assets/img/gallery/tech-dive.jpg',
        thumbnailImageSrc: 'assets/img/gallery/tech-dive.jpg',
        alt: 'ESPECIALISTAS EN SEGUROS SUBACUÁTICOS DESDE 2003',
        title: 'ESPECIALISTAS EN SEGUROS',
        subtitle: 'SUBACUÁTICOS DESDE 2003',
        href: '',
        class: 'image1',
      },
      {
        previewImageSrc: 'assets/img/gallery/buceadores-recreativos.jpg',
        thumbnailImageSrc: 'assets/img/gallery/buceadores-recreativos.jpg',
        alt: 'SCUBA MEDIC - Seguro de Accidentes de Buceo',
        title: 'SCUBA MEDIC',
        subtitle: 'Seguro de Accidentes de Buceo',
        href: '/es/scubamedic',
        class: 'image2',
      },
      {
        previewImageSrc: 'assets/img/gallery/instructores-divemasters.jpg',
        thumbnailImageSrc: 'assets/img/gallery/instructores-divemasters.jpg',
        alt: 'DIVE PRO - Seguro de Instructores de Buceo',
        title: 'DIVE PRO',
        subtitle: 'Seguro de Instructores de Buceo',
        href: '/es/seguro-buceo/instructor-divemaster/dive-pro',
        class: 'image3',
      },
      {
        previewImageSrc: 'assets/img/gallery/centros-buceo.jpg',
        thumbnailImageSrc: 'assets/img/gallery/centros-buceo.jpg',
        alt: 'Dive Center - Seguro para Centros y Escuelas de Buceo',
        title: 'Dive Center',
        subtitle: 'Seguro para Centros y Escuelas de Buceo',
        href: '/es/seguro-buceo/centro-buceo',
        class: 'image4',
      },
      {
        previewImageSrc: 'assets/img/gallery/buceo-profesional.jpg',
        thumbnailImageSrc: 'assets/img/gallery/buceo-profesional.jpg',
        alt: 'Sub Works - Seguro para empresas de buceo profesional',
        title: 'Sub Works',
        subtitle: 'Seguro para empresas de buceo profesional',
        href: '/es/seguro-buceo/buceo-profesional',
        class: 'image5',
      },
    ];
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
